import type { AuthErrorReason, AuthProfile } from "./types";

/**
 * A staff profile may read RLS-scoped data only when it is both approved and
 * active. `is_active` is NOT NULL in the schema (the parity migration backfills
 * legacy NULLs and adds the constraint), so only an explicit `true` is active.
 */
export function isApprovedProfile(profile: AuthProfile | null): profile is AuthProfile {
  return Boolean(profile) && profile?.approval_status === "approved" && profile?.is_active === true;
}

/**
 * A staff session could not be established or restored. `reason` drives the
 * login-page notice; `message` is the user-safe string shown on the form.
 */
export class StaffSessionError extends Error {
  readonly reason: AuthErrorReason;

  constructor(reason: AuthErrorReason, message: string) {
    super(message);
    this.name = "StaffSessionError";
    this.reason = reason;
  }
}
